import {Row, Col} from 'antd';
import {useFormikContext} from 'formik';
import {Input} from 'formik-antd';
import {useIntl} from 'react-intl';
import {useLocaleContext} from 'src/domain/utility/AppContextProvider/LocaleContextProvide';
import FormItem from 'src/shared/components/form-item';
import {
  getLocaleValue,
  handleChangeLocales,
} from 'src/shared/functions/change-locales';
import LanguageCode from 'src/shared/services/types/language-code';
import MainUtils from 'src/shared/utils/main';

interface IOptionModalStandardProps {}

const OptionModalStandard = (props: IOptionModalStandardProps) => {
  const {messages} = useIntl();

  const {setFieldValue, values} = useFormikContext<any>();

  const {locale}: any = useLocaleContext();

  return (
    <>
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <FormItem
            name='value'
            label={messages['common.description'].toString()}
            fieldCommponent={
              <Input.TextArea
                name={'value'}
                value={getLocaleValue(
                  values?.locales,
                  !MainUtils.isEmptyValue(locale.code)
                    ? locale.code
                    : LanguageCode.English,
                  'value',
                )}
                onChange={(value) =>
                  handleChangeLocales(
                    values?.locales,
                    setFieldValue,
                    `locales`,
                    !MainUtils.isEmptyValue(locale.code)
                      ? locale.code
                      : LanguageCode.English,
                    'value',
                    value.target.value,
                  )
                }
                rows={4}
              />
            }
          />
        </Col>
      </Row>
    </>
  );
};

export default OptionModalStandard;
